module.exports = __webpack_public_path__ + "img/gas.8f289986.svg";